var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderSidebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 770,
    viewBox: "0 0 180 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 22,
    rx: 4,
    fill: "#EFF2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#EFF2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 68,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#EFF2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 102,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 136,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 170,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 204,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 238,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 272,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 306,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 340,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 374,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 408,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    y: 442,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 476,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 510,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 544,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 578,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 612,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    y: 646,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    y: 680,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 714,
    width: 180,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    y: 748,
    width: 140,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSidebar);
export default __webpack_public_path__ + "static/media/loader-sidebar.9eeb219212dd30ec862bf12d47fcc6aa.svg";
export { ForwardRef as ReactComponent };